import { Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'

import { Button } from '@/components/button/button'

import { EXTERNAL_URLS } from '@/lib/constants/url'

export const PricingHeader = () => {
  return (
    <div className="flex items-center justify-between pb-[89px] pl-[51px] pr-[90px] pt-12">
      <div className="flex items-center text-3xl font-semibold text-primary-foreground">
        <Link to="/settings">
          <Button className="mr-5" variant="ghost" size="icon" asChild>
            <ArrowLeft size={36} />
          </Button>
        </Link>
        <div>Upgrade your plan</div>
      </div>
      <img src={EXTERNAL_URLS.lawfullyProFullLogoDark} alt="Lawfully Logo" />
    </div>
  )
}
